// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#top-header{position:relative;width:100%;height:100px;display:flex;justify-content:space-between;flex-shrink:0}#top-header .header-center-decoration{width:40%;height:60px;margin-top:30px}#top-header .header-left-decoration,#top-header .header-right-decoration{width:25%;height:60px}#top-header .center-title{position:absolute;font-size:30px;font-weight:700;left:50%;top:15px;transform:translateX(-50%)}", ""]);
// Exports
module.exports = exports;
